/**
 * Premium UI Enhancements
 * Magnetic Buttons & Micro-interactions
 */

document.addEventListener('DOMContentLoaded', () => {
  initMagneticButtons();
});

function initMagneticButtons() {
  const buttons = document.querySelectorAll('.button:not([disabled])');
  
  buttons.forEach(btn => {
    btn.addEventListener('mousemove', (e) => {
      const rect = btn.getBoundingClientRect();
      const x = e.clientX - rect.left - rect.width / 2;
      const y = e.clientY - rect.top - rect.height / 2;
      
      // Magnetic pull effect
      btn.style.transform = `translate(${x * 0.2}px, ${y * 0.3}px) scale(1.05)`;
    });
    
    btn.addEventListener('mouseleave', () => {
      btn.style.transform = '';
    });
  });
}
